var app = angular.module('directives.masterpassBanner');
var template = require('../templates/index.html');

app.directive('masterpassBanner', [
    'configs',
    '$translate',
    '$state',
    function(configs, $translate, $state) {
        return {
            restrict: 'E',
            template: template,
            scope: {
          },
            controller:'masterpassBanner'
        }
    }
]);

app.controller('masterpassBanner',function ($scope, $state, $translate, Storage) {

    $scope.closeMpBanner = function (data) {

        if (data) {
            $state.go('pages.mycards', {addMPCard: true});
        }
        $scope.masterpass.hide = true;
        Storage.mp_banner_hide = true;
    };

    function init () {
        $scope.masterpass = {
            status: Storage.mp_status || "",
            hide: Storage.mp_banner_hide || false
        }
    }

    init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/masterpassBanner/directives/masterpassBanner.js
 ** module id = 182
 ** module chunks = 1
 **/